module.exports = __webpack_public_path__ + "static/easy_to_maintain_LR-8cdc02a2dc8b2c6cd623729573a384b3.mp4";